module.exports = __webpack_public_path__ + "static/media/09_northgate_village-burnaby.9224dc31.jpg";